/* @flow */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { getEventNotifications } from 'common/redux/selectors/appPreferences';
import { toggleNotificationInfo } from 'common/redux/actions/eventNotifications';
import { WebNotificationState } from 'common/services/WebNotificationService';
import EventNotificationService from 'common/services/EventNotificationService';
import settingsTestIds from 'common/tests/mySettings/settings.json';

import Switch from 'common/components/core/switch';
import theme from './Notification.scss';

type Props = {
    t: Function,
    sendNotification: boolean,
    eventNotificationsPreferences: ?Object
};

class NotificationSettings extends PureComponent<Props> {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { eventNotificationsPreferences } = this.props;
        const {
            eventNotificationsPreferences: nextEventNotificationsPreferences
        } = nextProps;
        let nextNotificationState = 'off';
        if (
            eventNotificationsPreferences !== nextEventNotificationsPreferences
        ) {
            if (
                nextEventNotificationsPreferences &&
                nextEventNotificationsPreferences.notificationState
            ) {
                ({
                    notificationState: nextNotificationState
                } = nextEventNotificationsPreferences);
                if (EventNotificationService.isNewNotificationSupported()) {
                    Notification.requestPermission().then(permission => {
                        if (
                            permission ===
                                WebNotificationState.PERMISSION_DENIED &&
                            nextNotificationState === 'on'
                        ) {
                            EventNotificationService.setNotificationStateHandler(
                                nextNotificationState
                            );
                        }
                    });
                }
            }
        }
    }

    onNotificationToggle = (): void => {
        const {
            eventNotificationsPreferences,
            toggleNotificationInfo
        } = this.props;
        let previousNotificationState = 'off';
        let notificationInfoActive = false;
        if (
            eventNotificationsPreferences &&
            eventNotificationsPreferences.notificationState
        ) {
            ({
                notificationState: previousNotificationState,
                notificationInfoActive
            } = eventNotificationsPreferences);
        }
        let nextNotificationState = WebNotificationState.PERMISSION_DENIED;
        if (EventNotificationService.isNewNotificationSupported()) {
            Notification.requestPermission().then(permission => {
                if (permission === WebNotificationState.PERMISSION_DENIED) {
                    if (!notificationInfoActive) {
                        toggleNotificationInfo();
                    }
                } else if (
                    permission === WebNotificationState.PERMISSION_GRANTED
                ) {
                    nextNotificationState =
                        previousNotificationState === 'on'
                            ? WebNotificationState.PERMISSION_DENIED
                            : WebNotificationState.PERMISSION_GRANTED;
                }
                EventNotificationService.setNotificationStateHandler(
                    nextNotificationState
                );
            });
        }
    };

    render() {
        const { t, eventNotificationsPreferences } = this.props;
        const notificationState =
            (eventNotificationsPreferences &&
                eventNotificationsPreferences.notificationState) === 'on';
        return (
            <div className={theme.NotificationContainer}>
                <div className={theme.details}>
                    <div className={theme.heading}>
                        {t('enableNotifications')}
                    </div>
                    <div className={theme.note}>{t('notificationMessage')}</div>
                </div>
                <Switch
                    checked={notificationState}
                    onChange={this.onNotificationToggle}
                    testId={settingsTestIds.notificationToggle}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const eventNotificationsPreferences = getEventNotifications(state);
    return { eventNotificationsPreferences };
};

const connectedNotificationSettings = connect(mapStateToProps, {
    toggleNotificationInfo
})(NotificationSettings);

export default translate('settings')(connectedNotificationSettings);
